import React from 'react';
import styles from './_pre-qualification-message-dialog.module.scss';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DialogProps } from '../DialogProps';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

export interface PreQualificationMessageDialogProps extends DialogProps<void> {
  title: string;
  message: string;
  open: boolean;
  isSuccess: boolean; // true if the credit check was successful, false otherwise
  wasCreditHit: boolean; // true if the credit check was performed, false otherwise
}

export default function PreQualificationMessageDialog(props: PreQualificationMessageDialogProps) {
  return (
    <Dialog open={props.open} className={styles.preQualificationMessageDialogContainer}>
      <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
        {props.title}
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {
            props.isSuccess === true && (
              <h3 style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <CheckCircleOutlineIcon color='success' style={{ marginRight: '5px' }} />
                Thank you for your pre-qualification request.
              </h3>
            )
          }
          {
            props.isSuccess !== true && (
              <h3 style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <ErrorOutlineOutlinedIcon color='error' style={{ marginRight: '5px' }} />
                We were unable to complete your pre-qualification request.
              </h3>
            )
          }
          <div dangerouslySetInnerHTML={{ __html: props.message }}></div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            props.accept &&
              props.accept();
          }}
          color='primary'
          variant='contained'
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}